/**
 * CheckoutFooter — Rodapé com disclaimer de responsabilidade.
 *
 * RELEASE: 2026-08-10 v3.0.0 — Remove a faixa de marketing
 *          "Cobranças inteligentes by uaizy" (ícone + wordmark).
 * RELEASE: 2026-06-21 v2.1.0 — Substitui a palavra "Uaizy" da frase de marketing
 *          pela logo (ícone + wordmark) renderizada inline.
 * RELEASE: 2026-06-21 v2.0.0 — Remove selo "Conexão Bancária Segura"; adiciona
 *          disclaimer com nome/documento do recebedor isentando o Uaizy.
 * RELEASE: 2026-06-21 v1.0.0 — Versão inicial.
 */

interface CheckoutFooterProps {
  brand: string;
  /** Ex.: "CNPJ: 12.345.678/0001-90" — já formatado pelo container. */
  sellerDocument?: string;
}

export function CheckoutFooter({ brand, sellerDocument }: CheckoutFooterProps) {
  return (
    <footer className="bg-slate-50 border-t border-slate-200/60 px-4 md:px-9 py-4 md:py-5">
      <p className="text-[10px] text-slate-500 leading-relaxed md:text-right">
        Esta cobrança é de responsabilidade única e exclusiva de{' '}
        <span className="font-semibold text-slate-700">{brand}</span>
        {sellerDocument ? `, ${sellerDocument}` : ''}. O Uaizy não se
        responsabiliza pelo produto ou serviço prestado. Em caso de dúvida,
        entre em contato com seu fornecedor.
      </p>
    </footer>
  );
}
